import { LitElement, css, html, nothing } from '@lit'
import styles from '@nova/styles'

class ProductComplementaryProductsBlock extends LitElement {
  static properties = {
    initialHandles: {
      type: String,
    },
  }

  constructor() {
    super()

    this.handlesInCart = []
    this.initialHandles = ''
    this._complementaryProducts = []
    this._complementaryCacheKey = null
  }
  
  firstUpdated() {
    if (this.initialHandles) {
      this.handlesInCart = this.initialHandles?.split(',') || []
    }
  }
  
  willUpdate(changedProperties) {
    if (changedProperties.has('initialHandles')) {
      this.handlesInCart = this.initialHandles
        ? this.initialHandles.split(',').filter(Boolean)
        : []
      this._complementaryCacheKey = null
    }
  }

  _syncComplementaryProductsCache = () => {
    const complementaryProductsTemplate = this.querySelector(
      '#complementary-products-json',
    )

    if (!complementaryProductsTemplate) {
      this._complementaryProductsTitle = ''
      this._complementaryProducts = []
      this._complementaryCacheKey = null
      return
    }

    const cartHandlesKey = [...this.handlesInCart].sort().join('|')
    if (this._complementaryCacheKey === cartHandlesKey) return

    try {
      const complementaryProducts = JSON.parse(
        complementaryProductsTemplate.content.textContent.trim(),
      )
      const handlesInCart = this.handlesInCart
      const products = complementaryProducts.products.filter((product) => {
        return !product.handle.split(',').every((handle) => {
          return handlesInCart.includes(handle)
        })
      })

      this._complementaryProductsTitle = complementaryProducts.title
      this._complementaryProducts = products
    } catch (err) {
      console.error('Error parsing complementary products template', err)
      this._complementaryProductsTitle = ''
      this._complementaryProducts = []
    }

    this._complementaryCacheKey = cartHandlesKey
  }

  _renderComplementaryProducts = () => {
    this._syncComplementaryProductsCache()

    if (!this._complementaryProducts.length) return nothing

    return html`
      <product-complementary-products-list
        .recommendations=${this._complementaryProducts}
        .title=${this._complementaryProductsTitle}
      ></product-complementary-products-list>
    `
  }

  render() {
    return html`
      ${this._renderComplementaryProducts()}
    `
  }

  static styles = [
    styles.flex,
    css`
      :host {
        display: block;
      }
    `,
  ]
}

customElements.define('product-complementary-products-block', ProductComplementaryProductsBlock)
